module.exports = __webpack_public_path__ + "f6c7315dc4a36522fff6ffd7200b4d21.pdf";